import axiosInstance from "../axiosInstance";
import APIPaths from "../../utils/APIPaths";
import { toast } from "react-toastify";

export const getMedicalProductList = async (page, rowsPerPage, searchData) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_ALL_MEDICAL_PRODUCT_BY_ORG}/${page}/${rowsPerPage}`, {
      params: {
        text: searchData,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medical product list:", error);
      return [];
    });
  return response;
};

export const addMedicalProduct = async (reqObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.ADD_MEDICAL_PRODUCT,
      reqObj
    );

    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const item in error.response?.data?.errors) {
        toast.error(error.response?.data?.errors[item]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response?.data?.message);
    } else {
      toast.error(error.response?.data);
    }
  }
};

export const updateMedicalProduct = async (reqObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.UPDATE_MEDICAL_PRODUCT,
      reqObj
    );

    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const item in error.response?.data?.errors) {
        toast.error(error?.response?.data?.errors[item]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response?.data?.message);
    } else {
      toast.error(error?.response?.data);
    }
  }
};

export const deleteMedicalProduct = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_MEDICAL_PRODUCT_BY_ID}/${id}`
    );
    if (response.status === 200) {
      toast.success(response.data?.message);
      return response.data;
    }
  } catch (error) {
    if (error?.response?.data?.errors) {
      for (const item in error?.response?.data?.errors) {
        toast.error(error?.response?.data?.errors[item]);
      }
    } else {
      toast.error(error?.response?.data?.message);
    }
  }
};

export const addBatchForMedicalProduct = async (reqObj, id) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.ADD_MEDICAL_PRODUCT_BATCH_BY_PRODUCT_ID + id,
      reqObj
    );

    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const item in error.response?.data?.errors) {
        toast.error(error.response?.data?.errors[item]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response?.data?.message);
    } else {
      toast.error(error.response?.data);
    }
  }
};

export const getMedicalProductBatchList = async (id, page, rowsPerPage) => {
  const response = await axiosInstance
    .get(
      `${APIPaths.GET_ALL_MEDICAL_PRODUCT_BATCH_BY_PRODUCT_ID}/${id}/${page}/${rowsPerPage}`
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medical product Batch list:", error);
      return [];
    });
  return response;
};

export const getMedicalProductById = async (id) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_MEDICAL_PRODUCT_BY_ID}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medical product:", error);
      return [];
    });
  return response;
};

export const updateMedicalProductBatch = async (reqObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.UPDATE_MEDICAL_PRODUCT_BATCH_BY_ID,
      reqObj
    );

    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const item in error.response?.data?.errors) {
        toast.error(error?.response?.data?.errors[item]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response?.data?.message);
    } else {
      toast.error(error.response?.data);
    }
  }
};

export const deleteMedicalProductBatch = async (id, productId) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_MEDICAL_PRODUCT_BATCH_BY_ID}/${id}/${productId}`
    );
    if (response.status === 200) {
      toast.success(response.data?.message);
      return response.data;
    }
  } catch (error) {
    if (error?.response?.data?.errors) {
      for (const item in error?.response?.data?.errors) {
        toast.error(error?.response?.data?.errors[item]);
      }
    } else {
      toast.error(error?.response?.data?.message);
    }
  }
};

export const getMedicalProductListByMedicine = async (reqBody) => {
  const response = await axiosInstance
    .post(`${APIPaths.GET_AVAILABLE_MEDICAL_PRODUCT_BY_MEDICINE}`, reqBody)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medical product  list:", error);
      return [];
    });
  return response;
};

export const getMedicalProductBillCodes = async (reqBody) => {
  const response = await axiosInstance
    .post(`${APIPaths.GET_MEDICAL_PRODUCT_BILL_CODE}`, reqBody)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medical product  list:", error);
      return error.response?.data;
    });
  return response;
};

export const getMedicalProductsTransactionsList = async (page, rowsPerPage) => {
  const response = await axiosInstance
    .get(
      `${APIPaths.GET_ALL_MEDICAL_PRODUCT_TRANSACTION}/${page}/${rowsPerPage}`
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medical products transaction list:", error);
      return [];
    });
  return response;
};

export const downloadMedicalTransactionReport = async (data) => {
  try {
    const URL = APIPaths.GET_MEDICAL_PRODUCT_TRANSACTION_REPORT;
    const response = await axiosInstance.post(URL, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Medical product transactions file not available");
    }
  } catch (error) {
    toast.error("File download failed");
    console.error(error);
  }
};

export const uploadMedicalProductCsvService = async (data) => {
  const response = await axiosInstance
    .post(APIPaths.IMPORT_MEDICAL_PRODUCT, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        toast.error("Something went wrong");
        return { status: 500 };
      }
      return error.response;
    });
  return response;
};

export const downloadSampleMedicalProductZip = async () => {
  try {
    const URL = APIPaths.DOWNLOAD_SAMPLE_MEDICAL_PRODUCT_CSV;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/zip",
      },
    });
    if (response.status === 200) {
      toast.success("Sample ZIP folder downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Sample ZIP folder not available");
    }
  } catch (error) {
    toast.error("Sample ZIP folder download failed");
  }
};

export const uploadMedicalProductBatchCsvService = async (data) => {
  const response = await axiosInstance
    .post(APIPaths.IMPORT_MEDICAL_PRODUCT_BATCH, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        toast.error("Something went wrong");
        return { status: 500 };
      }
      return error.response;
    });
  return response;
};

export const downloadSampleMedicalProductBatchZip = async () => {
  try {
    const URL = APIPaths.DOWNLOAD_SAMPLE_MEDICAL_PRODUCT_BATCH_CSV;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/zip",
      },
    });
    if (response.status === 200) {
      toast.success("Sample ZIP folder downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Sample ZIP folder not available");
    }
  } catch (error) {
    toast.error("Sample ZIP folder download failed");
  }
};

export const downloadMedicalProductReport = async (data) => {
  try {
    const URL = APIPaths.GET_MEDICAL_PRODUCT_REPORT;
    const response = await axiosInstance.post(URL, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Medical product file not available");
    }
  } catch (error) {
    toast.error("File download failed");
    console.error(error);
  }
};

export const getAllUnits = async () => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_ALL_UNITS}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching unit list:", error);
      return [];
    });
  return response;
};

export const getUnitTypes = async () => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_ALL_UNIT_TYPES}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching unit list:", error);
      return [];
    });
  return response;
};

export const getAllParentUnitByChildId = async (id) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_ALL_PARENT_UNIT_BY_CHILD_ID}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching fetching parent units:", error);
      return [];
    });
  return response;
};

export const getBatchUnitFactors = async (batchUnitId, dispenseUnitId) => {
  const response = await axiosInstance
    .get(
      `${APIPaths.GET_CONVERSION_FACTOR_UNITS}/${batchUnitId}/${dispenseUnitId}`
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching fetching batch unit factors:", error);
      return [];
    });
  return response;
};

export const getAllUnitsByTypes = async (type) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_ALL_UNITS_BY_TYPE}`, {
      params: {
        type: type,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medical product list:", error);
      return [];
    });
  return response;
};

export const getAllDosageUnits = async () => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_DOSAGE_UNITS}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching unit list:", error);
      return [];
    });
  return response;
};

export const addUnit = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.CREATE_UNIT, reqObj);

    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const item in error.response?.data?.errors) {
        toast.error(error.response?.data?.errors[item]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response?.data?.message);
    } else {
      toast.error(error.response?.data);
    }
  }
};

export const getAllContentMeasurementUnits = async (id) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_CONTENT_MEASUREMENT_UNITS_BY_DISPENSE_UNIT}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching fetching parent units:", error);
      return [];
    });
  return response;
};

export const getSuggestedMedicalProductBatches = async (
  productId,
  duration,
  searchData,
  batchBillItems
) => {
  const response = await axiosInstance
    .post(`${APIPaths.SUGGEST_MEDICAL_PRODUCT_BATCH_BY_PRODUCT}`, {
      productId: Number(productId),
      duration: Number(duration),
      searchText: searchData || "",
      batchBillItems: batchBillItems || [],
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medical product batch list:", error);
      return [];
    });
  return response;
};

export const getContentMeasurementUnitMedicalProduct = async (productId) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_CONTENT_MEASUREMENT_UNIT_BY_PRODUCT}/${productId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching content measurement unit list:", error);
      return [];
    });
  return response;
};

export const addForm = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_FORM, null, {
      params: { form: reqObj.form },
    });

    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const item in error.response?.data?.errors) {
        toast.error(error.response?.data?.errors[item]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response?.data?.message);
    } else {
      toast.error(error.response?.data);
    }
  }
};

export const addStorageCondition = async (reqObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.ADD_STORAGE_CONDITION,
      null,
      {
        params: { condition: reqObj.condition },
      }
    );

    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const item in error.response?.data?.errors) {
        toast.error(error.response?.data?.errors[item]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response?.data?.message);
    } else {
      toast.error(error.response?.data);
    }
  }
};

export const getAllForm = async () => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_ALL_FROMS}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medicine form list:", error);
      return [];
    });
  return response;
};

export const getAllStorageConditions = async () => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_ALL_STORAGE_CONDITION}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching storage conditions list:", error);
      return [];
    });
  return response;
};

export const getAllSideEffects = async () => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_ALL_SIDE_EFFECT}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching medicine side effects list:", error);
      return [];
    });
  return response;
};

export const addSideEffect = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_SIDE_EFFECT, null, {
      params: { sideEffect: reqObj.sideEffect },
    });

    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const item in error.response?.data?.errors) {
        toast.error(error.response?.data?.errors[item]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response?.data?.message);
    } else {
      toast.error(error.response?.data);
    }
  }
};
